import React from 'react'
import { Spinner } from '@shopify/polaris'
import './GlobalLoader.scss'

const GlobalLoader = ({ isLoading }) => {
  if (!isLoading) return null

  return (
    <div className="global-loader-overlay">
      <Spinner size="large" />
    </div>
  )
}

export default GlobalLoader
